import { render, staticRenderFns } from "./budgetManagement.vue?vue&type=template&id=645d40c8&scoped=true"
import script from "./budgetManagement.vue?vue&type=script&lang=js"
export * from "./budgetManagement.vue?vue&type=script&lang=js"
import style0 from "./budgetManagement.vue?vue&type=style&index=0&id=645d40c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d40c8",
  null
  
)

export default component.exports